export default __webpack_public_path__ + "static/media/621.6dcf6021.gif";